import api from '../../services/api';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        threadHeader: [
            { text: 'Subject', value: 'subject', sortable: true},
            { text: 'Filename', value: 'attachmentFilename ', sortable: true },
            { text: 'Date Received', value: 'date ', sortable: true },
            { text: 'Actions', align: 'center', alignHeader: 'center' }
        ],
        threadItems: [],
        threadLoading: false,
        disableFilter: false,
        limit:0,
        brandName: '',
        loading: false,
        exportData: [],
        exportHeaders: [
            { header: "VENDOR NAME", key: 'vendorName', width: '20' },
            { header: "BILL NO", key: 'invoiceNumber', width: '20' },
            { header: "BILL DATE", key: 'invoiceDate', width: '20' },
            { header: "TERMS", key: 'netTerm', width: '15' },
            { header: "CATEGORY", key: 'category', width: '15' },
            { header: "DESCRIPTION", key: 'poNumber', width: '20' },
            { header: "AMOUNT", key: 'totalAmount', width: '20' },
            { header: "CLASS", key: 'className', width: '15' },
            { header: "BRAND (DELETE before Upload)", key: 'brandName', width: '30'}
        ],
        exportHeadersOnly: [
            { header: "Brand", key: 'brandName'},
            { header: "Invoice No.", key: 'invoiceNumber'},
            { header: "Invoice Date", key: 'invoiceDate'},
            { header: "PO No.", key: 'poNumber'},
            { header: "PO Date", key: 'ipoDate'},
            { header: "Total Amount", key: 'totalAmount'},
            { header: "Total Qty", key: 'totalQuantity'},
            { header: "Ship To", key: 'shipTo'},
            { header: "Bill To", key: 'billTo'},
        ],
        exportFullHeaders: [
            { header: "Brand", key: 'brandName'},
            { header: "Invoice No.", key: 'invoiceNumber'},
            { header: "Invoice Date", key: 'invoiceDate'},
            { header: "PO No.", key: 'poNumber'},
            { header: "PO Date", key: 'ipoDate'},
            { header: "Total Amount", key: 'totalAmount'},
            { header: "Total Qty", key: 'totalQuantity'},
            { header: "Ship To", key: 'shipTo'},
            { header: "Bill To", key: 'billTo'},
            { header: "Line", key: 'line'},
            { header: "Vendor No.", key: 'vendorNumber'},
            { header: "UPC No.", key: 'upcNumber'},
            { header: "Buyer No.", key: 'buyerNumber'},
            { header: "Qty", key: 'quantity' },
            { header: "Unit of Measure", key: 'unitOfMeasure'},
            { header: "Unit Price", key: 'unitPrice'},
            { header: "Case Pack", key: 'casePack'},
            { header: "Extended Price", key: 'extendedPrice'}
        ],
        exportFormat: ''
    },
    getters: {
        getDisableFilter: state => state.disableFilter,
        getThreadHeader: state => state.threadHeader,
        getThreadItems: state => state.threadItems,
        getThreadLoading: state => state.threadLoading,
    },
    mutations: {
        setThreadLoading: (state, payload) => state.threadLoading = payload,
        setDisableFilter: (state, payload) => state.disableFilter = payload,
        [type.GMAIL_LOAD_MESSAGES]: (state, payload) => state.threadItems = payload
    },
    actions: {
        [type.GMAIL_LOAD_MESSAGES]: async ({commit}, payload) => {
            commit('setDisableFilter', true);
            let sender = payload.sender ? `from:${payload.sender} ` : '';
            let brand = payload.brand ? `has:attachment ${payload.brand} * .html ` : '';
            let after = payload.dateRange.startDate ? `after: ${this.formatDateRange(payload.dateRange.startDate)} `: '';
            let before = payload.dateRange.endDate ? `before: ${this.formatDateRange(payload.dateRange.endDate)} `: '';
            
            let query = sender || brand ? `q=${sender}${brand}${after}${before}` : '';
            if(payload.search){
                query =  `q=from:(${payload.sender}) filename: .html ${payload.search}`
            }
            let limit = this.limit > 0 ? `&limit=${this.limit}` : '';
            console.log(query)
            try{
                commit('setThreadLoading', true);
                let response = await axios.get(`api/edi/messages?${query}${limit}`);
                commit(type.GMAIL_LOAD_MESSAGES, response.data.map(e => {
                    return {...e, isExtracted: false, isLoading: false}
                }))
            }catch(error){
                commit(`global/${type.SET_NOTIFICATION}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit('setThreadLoading', false)
                commit('setDisableFilter', false)
            }
        }
    }
} 